import React from 'react'
import PropTypes from 'prop-types'
import TableHeader from './TableHeader'
import TableBody from './TableBody'


export const Table = ({ objectList, idProperty, orderBy, filter, changeFilter, filterSetting, toggleSort, toggleMultiSort, columnList, onRowClick, onRowDoubleClick, hiddenColumns }) => {
    return (<table className="default-table">

        <TableHeader
            orderBy={orderBy}
            filter={filter}
            changeFilter={changeFilter}
            toggleSort={toggleSort}
            toggleMultiSort={toggleMultiSort}
            columnList={columnList}
            filterSetting={filterSetting}
            hiddenColumns={hiddenColumns}
        />

        <TableBody
            objectList={objectList}
            idProperty={idProperty}
            columnList={columnList}
            onRowClick={onRowClick}
            onRowDoubleClick={onRowDoubleClick}
            hiddenColumns={hiddenColumns}
        />

    </table>)
}

Table.propTypes = {
    currentPage: PropTypes.number.isRequired,
    columnList: PropTypes.array.isRequired,
    objectPerPage: PropTypes.number.isRequired,
    filter: PropTypes.object.isRequired,
    orderBy: PropTypes.object.isRequired,
    objectList: PropTypes.array.isRequired,
    changeFilter: PropTypes.func.isRequired,
    toggleSort: PropTypes.func.isRequired,
    toggleMultiSort: PropTypes.func.isRequired,
    gotoPage: PropTypes.func.isRequired,
    idProperty: PropTypes.string.isRequired,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
    filterSetting: PropTypes.object,
}

export default Table





// WEBPACK FOOTER //
// ./src/modules/table/component/Table.js